import { getCurrentInstance } from 'vue';
import type { MainInjector } from '@/di/injector';

export function useInjector(): MainInjector {
    const vm = getCurrentInstance();
    if (!vm) {
        throw new Error('You must use this function within the "setup()" method');
    }

    return vm.proxy.$injector;
}
